module.exports = __webpack_public_path__ + "img/banner-prouni-2022-1920x260.df81861f.png";